<template>
  <b-card v-if="dataForChart && dataForChart.length" no-body class="mb-3">
    <b-card-body>
      <h4>Федеральные округа</h4>
      <pie-chart
        :chart-data="filteredData.data"
        :labels="filteredData.labels"
        :colors="filteredData.colors"
        :year="currentYear"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import PieChart from '@/components/statistic/PieChart.vue'
import statisticsApi from '@/api/statistics'
import { federalDistricts } from '@/config/districts'

export default {
  name: 'Districts',
  components: {
    PieChart
  },
  data() {
    return {
      labelsForChart: federalDistricts.map((fd) => fd.title),
      colorsForChart: federalDistricts.map((fd) => fd.color),
      currentYear: 0
    }
  },
  async created() {
    this.currentYear = Number((await statisticsApi.getStatisticYear()).data.year)
  },
  computed: {
    ...mapGetters({
      gpClasses: 'content/getGPClasses',
      statsClassesStudentsDistribution: 'statistics/getStatsClassesStudentsDistribution'
    }),
    filteredData() {
      const notEmptyIndexes = _.keys(this.dataForChart).filter((key) => this.dataForChart[key] > 0)
      return {
        labels: notEmptyIndexes.map((index) => this.labelsForChart[index]),
        data: notEmptyIndexes.map((index) => this.dataForChart[index]),
        colors: notEmptyIndexes.map((index) => this.colorsForChart[index])
      }
    },
    dataForChart() {
      if (!this.currentYear) {
        return []
      }
      const schools = this.gpClasses.filter((c) => c.position && !c.disabledAsSchool)
      const districts = federalDistricts.map(() => 0)
      for (const school of schools) {
        const dataForOrganization = this.statsClassesStudentsDistribution
          .find((p) => p.organizationId === school.id)
        if (dataForOrganization && _.isNumber(dataForOrganization[this.currentYear])) {
          const indexDistrict = federalDistricts
            .findIndex((fd) => fd.subjects.includes(school.region))
          if (indexDistrict > -1) {
            districts[indexDistrict] += dataForOrganization[this.currentYear]
          }
        }
      }
      return districts
    }
  }
}
</script>

<style scoped>

</style>
